// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const froslass: PokeData = {
  "id": 478,
  "name": "froslass",
  "height": 13,
  "weight": 266,
  "base_experience": 168,
  "types": [
    PokeType.ICE,
    PokeType.GHOST
  ],
  "api_moves": [
    "headbutt",
    "leer",
    "bite",
    "blizzard",
    "double-team",
    "confuse-ray",
    "powder-snow",
    "protect",
    "destiny-bond",
    "icy-wind",
    "crunch",
    "shadow-ball",
    "hail",
    "will-o-wisp",
    "astonish",
    "wake-up-slap",
    "ice-shard",
    "ice-fang",
    "captivate",
    "ominous-wind",
    "hex",
    "frost-breath",
    "icicle-crash",
    "draining-kiss",
    "aurora-veil",
    "snowscape"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "blizzard",
    "confuse-ray",
    "protect",
    "crunch",
    "shadow-ball",
    "ice-shard",
    "ice-fang",
    "aurora-veil",
    "lick",
    "night-shade"
  ],
  "evolution_chain": {
    "id": 186,
    "item": null,
    "species": [
      {
        "name": "snorunt",
        "order": 390,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "glalie",
        "order": 391,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 361,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "froslass",
        "order": 392,
        "types": [
          PokeType.ICE,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 361,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dawn-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 169,
    "ability_power": 123
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
